import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { EnvironmentService } from '@ts/shared/util-environment';

import { RouterUrlAbstractService } from './router-url.abstract.service';

@Injectable({
  providedIn: 'root',
})
export class RouterUrlSoluiService extends RouterUrlAbstractService {
  baseUrl: string;

  constructor() {
    const router = inject(Router);
    const environmentService = inject(EnvironmentService);

    super(router);
    this.baseUrl = environmentService.get().soluiUrl;
  }
}
